import { useEffect, useState } from "react";
import sidenav from "../utils/api/sidenav";
import { useAuthContext } from "../context/AuthContext";

export const useSidenav = () => {
  const [loading, setLoading] = useState(false);
  const [sidenavData, setSidenavData] = useState([]);
  const [error, setError] = useState(null);
  const { setAuthUser } = useAuthContext();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data } = await sidenav(setAuthUser);
        setSidenavData(data);
      } catch (error) {
        if (error.status !== 401) {
          setError(error.message);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setAuthUser]);
  return { loading, sidenavData, error };
};
